import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import PaletteIcon from '@mui/icons-material/Palette';
import PetsIcon from '@mui/icons-material/Pets';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import * as React from 'react';

export type TCategoriesMenuItem = {
  id: string;
  nameKey: string;
  icon: React.ReactNode;
  subCategories: Array<{ id: string; nameKey: string }>;
};

/** Phone cases page — filters / related UI (kept for product list constants) */
export const PHONE_CASES_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'phone-cases',
  nameKey: 'nav.category.phonecases.label',
  icon: <PhoneIphoneIcon color="primary" />,
  subCategories: [
    { id: 'phone-cases-all', nameKey: 'nav.subcategory.all' },
    { id: 'builder', nameKey: 'nav.subcategory.phonecases.builder' },
    {
      id: 'phone-cases-bestsellers',
      nameKey: 'nav.subcategory.phonecases.bestsellers',
    },
    { id: 'phone-cases-new', nameKey: 'nav.subcategory.phonecases.new' },
  ],
};

/** Top-level category + subcategory links for header / navigation mocks */

export const KEYCHAINS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'keychains',
  nameKey: 'nav.category.keychains.label',
  icon: <VpnKeyIcon color="primary" />,
  subCategories: [
    { id: 'keychains-all', nameKey: 'nav.subcategory.all' },
    { id: 'keychains-metal', nameKey: 'nav.subcategory.keychains.metal' },
    { id: 'keychains-acrylic', nameKey: 'nav.subcategory.keychains.acrylic' },
    { id: 'keychains-leather', nameKey: 'nav.subcategory.keychains.leather' },
    {
      id: 'keychains-engraved',
      nameKey: 'nav.subcategory.keychains.engraved',
    },
    { id: 'keychains-gift', nameKey: 'nav.subcategory.keychains.gift' },
  ],
};

export const PETS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'pets',
  nameKey: 'nav.category.pets.label',
  icon: <PetsIcon color="primary" />,
  subCategories: [
    { id: 'pets-all', nameKey: 'nav.subcategory.all' },
    { id: 'pets-dogs', nameKey: 'nav.subcategory.pets.dogs' },
    { id: 'pets-cats', nameKey: 'nav.subcategory.pets.cats' },
    {
      id: 'pets-small-animals',
      nameKey: 'nav.subcategory.pets.small.animals',
    },
    { id: 'pets-accessories', nameKey: 'nav.subcategory.pets.accessories' },
    { id: 'pets-toys', nameKey: 'nav.subcategory.pets.toys' },
  ],
};

export const PAINTINGS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'paintings',
  nameKey: 'nav.category.paintings.label',
  icon: <PaletteIcon color="primary" />,
  subCategories: [
    { id: 'paintings-all', nameKey: 'nav.subcategory.all' },
    { id: 'paintings-canvas', nameKey: 'nav.subcategory.paintings.canvas' },
    {
      id: 'paintings-posters',
      nameKey: 'nav.subcategory.paintings.posters',
    },
    { id: 'paintings-framed', nameKey: 'nav.subcategory.paintings.framed' },
    {
      id: 'paintings-abstract',
      nameKey: 'nav.subcategory.paintings.abstract',
    },
    {
      id: 'paintings-landscape',
      nameKey: 'nav.subcategory.paintings.landscape',
    },
  ],
};

export const FIDGETS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'fidgets',
  nameKey: 'nav.category.fidgets.label',
  icon: <SportsEsportsIcon color="primary" />,
  subCategories: [
    { id: 'fidgets-all', nameKey: 'nav.subcategory.all' },
    { id: 'fidgets-spinners', nameKey: 'nav.subcategory.fidgets.spinners' },
    { id: 'fidgets-cubes', nameKey: 'nav.subcategory.fidgets.cubes' },
    { id: 'fidgets-popit', nameKey: 'nav.subcategory.fidgets.popit' },
    { id: 'fidgets-stress', nameKey: 'nav.subcategory.fidgets.stress' },
    { id: 'fidgets-edc', nameKey: 'nav.subcategory.fidgets.edc' },
  ],
};

export const CUPS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'cups',
  nameKey: 'nav.category.cups.label',
  icon: <LocalCafeIcon color="primary" />,
  subCategories: [
    { id: 'cups-all', nameKey: 'nav.subcategory.all' },
    { id: 'cups-mugs', nameKey: 'nav.subcategory.cups.mugs' },
    { id: 'cups-travel', nameKey: 'nav.subcategory.cups.travel' },
    { id: 'cups-thermos', nameKey: 'nav.subcategory.cups.thermos' },
    {
      id: 'cups-personalized',
      nameKey: 'nav.subcategory.cups.personalized',
    },
    { id: 'cups-sets', nameKey: 'nav.subcategory.cups.sets' },
  ],
};

/** Full navigation mock: order matches typical shop priority */
export const CATEGORIES_MENU_CONFIG: Array<TCategoriesMenuItem> = [
  PHONE_CASES_CATEGORIES_MENU_CONFIG,
  KEYCHAINS_CATEGORIES_MENU_CONFIG,
  PETS_CATEGORIES_MENU_CONFIG,
  PAINTINGS_CATEGORIES_MENU_CONFIG,
  FIDGETS_CATEGORIES_MENU_CONFIG,
  CUPS_CATEGORIES_MENU_CONFIG,
];
